module.exports = __webpack_public_path__ + "../resources/img/bg_pictogram_line.defcf635.png";